// extracted by mini-css-extract-plugin
module.exports = {"validCheckbox":"checkbox_validCheckbox__31CNZ","checkIcon":"checkbox_checkIcon__34quE","closeIcon":"checkbox_closeIcon__1GstO"};